export type HistoryRunStatus = "PENDING" | "PROCESSING" | "UPDATED" | "FAILED"

export interface ISkcHistoryRecord {
  _id: string
  isRun?: HistoryRunStatus
  status?: HistoryRunStatus
  campaignName: string
  oldBid: number
  old_TOS_modifire: number
  old_ROS_modifire: number
  old_PP_modifire: number
  old_AB_modifire: number
  old_AD_modifire: number
  old_FV_modifire?: number
  old_TOB_modifire?: number
  old_ROB_modifire?: number
  old_audienceId: string
  newKeywordBid: number
  TOS_modifire: number
  ROS_modifire: number
  PP_modifire: number
  AB_modifire: number
  AD_modifire: number
  FV_modifire?: number
  TOB_modifire?: number
  ROB_modifire?: number
  audienceId: string
  createdAt: string
  updatedAt: string
}

export interface ISbSdHistoryRecord {
  _id: string
  isRun: HistoryRunStatus
  campaignName: string | null
  campaignId?: string | null
  targetId: string
  targetName: string
  oldBid?: number | null
  bid?: number | null
  placementsBefore?: string | null
  placementsAfter?: string | null
  createdAt: string
  updatedAt: string
}

export enum SbSdCampaignType {
  SPONSORED_BRANDS = "Sponsored Brands",
  SPONSORED_DISPLAY = "Sponsored Display",
}

export interface IPlacementHistoryRecord {
  _id: string
  campaignId: string
  campaignName: string | null
  placement: string
  oldPercentage: number | null
  newPercentage: number | null
  oldAudienceId: string | null
  newAudienceId: string | null
  oldAudienceName: string | null
  newAudienceName: string | null
  status: string
  date: string
  createdAt: string
  updatedAt: string
}
